(function(){
    angular
        .module('maApp.core')
        .config(configure);

    configure.$inject = ['$locationProvider', 'localStorageServiceProvider', '$logProvider', '$compileProvider', 'uiZeroclipConfigProvider', 'localStoragePrefix'];

    function configure($locationProvider, localStorageServiceProvider, $logProvider, $compileProvider, uiZeroclipConfigProvider, localStoragePrefixName) {
        localStorageServiceProvider
            .setPrefix(localStoragePrefixName)
            .setNotify(true, true);

        $locationProvider.html5Mode(true);
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
        uiZeroclipConfigProvider.setZcConf({
            swfPath: 'node_modules/zeroclipboard/dist/ZeroClipboard.swf'
        });
    }

})();